import React from 'react';
import styled from 'styled-components';
import { ResponsiveContainer, PieChart, Pie, Cell } from 'recharts';
import { DarkCard, PieLegend, LegendItem } from './DashboardStyles';
import { CustomPieLabel } from './ChartUtils';
import MexicoMap from '../MexicoMap';

const MixLayout = styled.div`
  display: flex;
  gap: 8px;
  align-items: center;
  justify-content: space-between;
`;

const MixLeft = styled.div`
  flex: 0 0 140px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-width: 0;
`;

const MapWrapper = styled.div`
  flex: 1;
  height: 240px;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
`;

const MembershipMixCard = ({ membershipData = [], mexicoHeatmapData = [] }) => {
    return (
        <DarkCard>
            <div className="card-title">Mix de Membresías</div>
            <MixLayout>
                <MixLeft>
                    <ResponsiveContainer width="100%" height={140}>
                        <PieChart>
                            <Pie
                                data={membershipData}
                                cx="50%"
                                cy="50%"
                                innerRadius={25}
                                outerRadius={55}
                                dataKey="value"
                                labelLine={false}
                                label={<CustomPieLabel />}
                            >
                                {membershipData.map((entry, index) => (
                                    <Cell key={`cell-${index}`} fill={entry.color} />
                                ))}
                            </Pie>
                        </PieChart>
                    </ResponsiveContainer>
                    <PieLegend style={{
                        flexDirection: 'row',
                        justifyContent: 'center',
                        gap: '8px 12px',
                        flexWrap: 'wrap',
                        width: '100%',
                        padding: '0 8px'
                    }}>
                        {membershipData.map((item) => (
                            <LegendItem key={item.name} color={item.color} style={{ fontSize: '10px' }}>
                                <div className="dot" />
                                {item.name}
                            </LegendItem>
                        ))}
                    </PieLegend>
                </MixLeft>
                <MapWrapper>
                    <MexicoMap data={mexicoHeatmapData} />
                </MapWrapper>
            </MixLayout>
        </DarkCard>
    );
};

export default MembershipMixCard;
